
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/rent-budget-calculator",
      function () {
        return require("private-next-pages/calculators/rent-budget-calculator.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/rent-budget-calculator"])
      });
    }
  